export default __webpack_public_path__ + "using-shake-live-chat.jpg";